import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileBottomBar from "@/components/feature/MobileBottomBar";

export default function Kontakt() {
  return (
    <>
      <Navbar />
      <main className="pt-24 md:pt-28 min-h-screen">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24">
          <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
            Kontakt & Anfahrt
          </h1>
          <div className="space-y-6 text-foreground-700">
            <div>
              <h2 className="font-heading text-xl text-foreground-950 mb-2">Florale Manufaktur Blumen Stöhr GmbH</h2>
              <p>Heisfelder Straße 105</p>
              <p>26789 Leer (Ostfriesland)</p>
            </div>

            {/* Kontakt-Panel in Firmenfarben */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              <a
                href="tel:+494914238"
                className="flex items-center gap-4 p-4 bg-primary-50 border border-primary-200 rounded-lg hover:bg-primary-100 transition-colors group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-500 text-background-50 rounded-full shrink-0 group-hover:bg-primary-600 transition-colors">
                  <i className="ri-phone-line w-6 h-6 flex items-center justify-center text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide font-medium">Telefon</p>
                  <p className="text-lg font-semibold text-foreground-950">0491 4238</p>
                </div>
              </a>

              <a
                href="mailto:info@blumen-stoehr.de"
                className="flex items-center gap-4 p-4 bg-secondary-50 border border-secondary-200 rounded-lg hover:bg-secondary-100 transition-colors group"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-secondary-500 text-background-50 rounded-full shrink-0 group-hover:bg-secondary-600 transition-colors">
                  <i className="ri-mail-line w-6 h-6 flex items-center justify-center text-xl" />
                </div>
                <div>
                  <p className="text-xs text-foreground-500 uppercase tracking-wide font-medium">E-Mail</p>
                  <p className="text-lg font-semibold text-foreground-950">info@blumen-stoehr.de</p>
                </div>
              </a>
            </div>

            <div>
              <p>International: +49 491 4238</p>
            </div>

            <div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">Öffnungszeiten</h3>
              <div className="space-y-1 text-sm">
                <p>Montag: 08:30–18:00 Uhr</p>
                <p>Dienstag: 08:30–18:00 Uhr</p>
                <p>Mittwoch: geschlossen</p>
                <p>Donnerstag: 08:30–18:00 Uhr</p>
                <p>Freitag: 08:30–18:00 Uhr</p>
                <p>Samstag: 08:30–13:00 Uhr</p>
                <p>Sonntag: 10:30–12:30 Uhr</p>
              </div>
              <p className="text-foreground-500 text-sm mt-3">
                An Feiertagen und zu besonderen Anlässen können abweichende Öffnungszeiten gelten.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-6">
              <a href="tel:+494914238" className="inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
                Jetzt anrufen
              </a>
              <a href="https://www.google.com/maps/search/?api=1&query=Florale+Manufaktur+Blumen+Stoehr%2C+Heisfelder+Strasse+105%2C+26789+Leer" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-3.5 border border-primary-300 text-primary-700 rounded-md text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap">
                Route planen
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <MobileBottomBar />
    </>
  );
}